import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%"
  }
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  class: "account-name-edit-input-box"
};
const _hoisted_5 = ["placeholder", "value", "onChange"];
const _hoisted_6 = {
  class: "ads-accounts-wrapper"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1,
  class: "d-flex align-item-center justify-content-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_connection_page_title = _resolveComponent("connection-page-title");
  const _component_b_th = _resolveComponent("b-th");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_b_thead = _resolveComponent("b-thead");
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_td = _resolveComponent("b-td");
  const _component_account_connection_status = _resolveComponent("account-connection-status");
  const _component_advertising_account_with_flag = _resolveComponent("advertising-account-with-flag");
  const _component_stroked_plus_icon = _resolveComponent("stroked-plus-icon");
  const _component_b_button = _resolveComponent("b-button");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_col = _resolveComponent("b-col");
  const _component_app_button = _resolveComponent("app-button");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_tbody = _resolveComponent("b-tbody");
  const _component_b_table_simple = _resolveComponent("b-table-simple");
  const _component_app_modal = _resolveComponent("app-modal");
  const _component_create_account_side_bar = _resolveComponent("create-account-side-bar");
  const _component_advertising_account_side_bar = _resolveComponent("advertising-account-side-bar");
  const _component_app_card_connections = _resolveComponent("app-card-connections");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_connection_page_title, {
    class: "",
    visibleButton: $options.canAddAccount,
    action: "Add Account",
    searchPlaceHolder: $data.searchPlaceHolder,
    onAction: _cache[0] || (_cache[0] = $event => $data.createAccountSideBar = $options.canAddAccount)
  }, null, 8, ["visibleButton", "searchPlaceHolder"]), _createVNode(_component_app_card_connections, {
    class: "no-left-right-margin",
    loading: $data.dataLoading,
    "min-height": 300,
    scrollable: true,
    hasBorder: false
  }, {
    default: _withCtx(() => [!$data.dataLoading && $options.accounts.length > 0 ? (_openBlock(), _createBlock(_component_b_table_simple, {
      key: 0,
      striped: "",
      responsive: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_b_thead, {
        class: "account-table-thead-background"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_tr, null, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Account Name")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Account ID")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Region")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Connection status")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Advertising Accounts")]),
            _: 1
          }), _createVNode(_component_b_th, {
            class: "account-table-thead-background-text"
          }, {
            default: _withCtx(() => [_createTextVNode("Credentials")]),
            _: 1
          }), _createVNode(_component_b_th, {
            style: {
              "width": "0"
            }
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_b_tbody, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.accounts, account => {
          return _openBlock(), _createBlock(_component_b_tr, {
            key: account.account_id
          }, {
            default: _withCtx(() => [_createVNode(_component_b_td, {
              class: "align-middle",
              style: {
                "padding": "unset"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$data.accountNameEditId === account.account_id && $data.nameEditLoading ? (_openBlock(), _createBlock(_component_b_spinner, {
                key: 0,
                small: "",
                style: {
                  "align-self": "stretch",
                  "margin": "0 auto"
                }
              })) : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["account-name-container", {
                  edit: $data.accountNameEditId === account.account_id,
                  editable: account.account_provider === 'Amazon Vendor Central'
                }]),
                onClick: $event => $options.onAccountNameClick(account)
              }, [$data.accountNameEditId !== account.account_id ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(account.account_name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("input", {
                type: "text",
                placeholder: $options.splitAccountName(account.account_name).name,
                value: $options.splitAccountName(account.account_name).name,
                class: "account-name-edit-input",
                autofocus: "",
                onChange: $event => $options.onAccountNameChange($event, account),
                onBlur: _cache[1] || (_cache[1] = () => {
                  $data.accountNameEditId = '';
                })
              }, null, 40, _hoisted_5), _createTextVNode(" - " + _toDisplayString($options.splitAccountName(account.account_name).country) + " - " + _toDisplayString($options.splitAccountName(account.account_name).type), 1)]))], 10, _hoisted_2))])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(account.account_id), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(account.region), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle"
            }, {
              default: _withCtx(() => [_createVNode(_component_account_connection_status, {
                status: account.credential_status,
                onReauthenticateAccount: $event => $options.reauthenticateAccount(account)
              }, null, 8, ["status", "onReauthenticateAccount"])]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle col-md-4"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_ctx.amazonAdvertisingProfilesForAccount(account).length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
                key: 0
              }, _renderList(_ctx.amazonAdvertisingProfilesForAccount(account), profile => {
                return _openBlock(), _createBlock(_component_advertising_account_with_flag, {
                  profile: profile,
                  status: profile.credential_status,
                  onReauthenticateAccount: $event => $options.reauthenticateAccount(profile),
                  key: profile.account_id,
                  id: profile.account_id
                }, null, 8, ["profile", "status", "onReauthenticateAccount", "id"]);
              }), 128)) : _createCommentVNode("", true), _ctx.amazonAdvertisingProfilesForAccount(account) > 0 && !_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_b_button, {
                key: 1,
                variant: "link",
                onClick: $event => $options.openSideBar(account),
                class: "plus-button"
              }, {
                default: _withCtx(() => [_createVNode(_component_stroked_plus_icon, {
                  color: "#616161"
                })]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)]), _ctx.amazonAdvertisingProfilesForAccount(account).length == 0 ? (_openBlock(), _createBlock(_component_b_row, {
                key: 0
              }, {
                default: _withCtx(() => [_createVNode(_component_b_col, {
                  cols: "6",
                  class: "not-connected"
                }, {
                  default: _withCtx(() => [_createElementVNode("span", null, [_createVNode(_component_app_icon, {
                    icon: "cross-new-ui",
                    color: "#db333b",
                    class: "not-connected-icon"
                  }), _createTextVNode(" Not Connected")])]),
                  _: 1
                }), _createVNode(_component_b_col, {
                  cols: "6"
                }, {
                  default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 0,
                    variant: "outline-primary",
                    onClick: $event => $options.onConnect(account)
                  }, {
                    default: _withCtx(() => [_createTextVNode(" Connect ")]),
                    _: 2
                  }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, {
              class: "align-middle"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(account.credentials), 1)]),
              _: 2
            }, 1024), _createVNode(_component_b_td, null, {
              default: _withCtx(() => [!_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_app_button, {
                loading: account.account_id == $data.removeId ? $data.removeLoading : null,
                variant: "link",
                onClick: $event => $options.onRemove(account.account_id)
              }, {
                default: _withCtx(() => [_createVNode(_component_app_icon, {
                  icon: "remove"
                })]),
                _: 2
              }, 1032, ["loading", "onClick"])])) : _createCommentVNode("", true)]),
              _: 2
            }, 1024)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), !$data.dataLoading && $options.accounts.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, " You have not any accounts yet ")) : _createCommentVNode("", true), _createVNode(_component_app_modal, {
      modelValue: $data.confirmRemoveModal,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.confirmRemoveModal = $event),
      title: "Confirm Account Removing",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onRemoveConfirm
    }, {
      default: _withCtx(() => [_createTextVNode(" Are you sure you want to remove this account ? ")]),
      _: 1
    }, 8, ["modelValue", "onOk"]), _createVNode(_component_app_modal, {
      modelValue: $data.confirmAccountNameEditModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.confirmAccountNameEditModal = $event),
      title: "Confirm Account Name Edit",
      "cancel-title": "No",
      "ok-title": "Yes",
      onOk: $options.onConfirmAccountNameEdit
    }, {
      default: _withCtx(() => [_createTextVNode(" Are you sure you want to change this account name to " + _toDisplayString($data.updatedAccount.account_name) + "? ", 1)]),
      _: 1
    }, 8, ["modelValue", "onOk"]), $data.createAccountSideBar ? (_openBlock(), _createBlock(_component_create_account_side_bar, {
      key: 2,
      modelValue: $data.createAccountSideBar,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.createAccountSideBar = $event),
      provider: $props.provider,
      regions: $data.regions,
      countries: $data.countries,
      hasCountries: true
    }, null, 8, ["modelValue", "provider", "regions", "countries"])) : _createCommentVNode("", true), $data.advertisingAccountSideBar ? (_openBlock(), _createBlock(_component_advertising_account_side_bar, {
      key: 3,
      modelValue: $data.advertisingAccountSideBar,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.advertisingAccountSideBar = $event),
      account: $data.sideBarAccount,
      account_type: $data.accountTypes[$data.sideBarAccount.account_provider],
      profiles: _ctx.amazonAdvertisingProfilesForAccount($data.sideBarAccount),
      onRefresh: $options.refreshAdvertisingAccountSideBar
    }, null, 8, ["modelValue", "account", "account_type", "profiles", "onRefresh"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["loading"])]);
}